/* eslint-disable @typescript-eslint/no-floating-promises */
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { CTAButtonAndDisclaimerProps } from './productInterfaces'
import { TAP_BTN_EVENT } from '../constants'
import styles from '../productWidget.module.scss'

const ProductCTAButtonAndDisclaimer: React.FC<CTAButtonAndDisclaimerProps> = ({
  content,
  segmentEventCommonProperties,
}) => {
  const handleButtonClick = () => {
    ;(async () => {
      await trackEvent(TAP_BTN_EVENT, {
        ...segmentEventCommonProperties,
        funnel: 'engage',
        source: content?.cta?.name,
      })
      window.location.href = content?.cta?.link
    })()
  }

  return (
    <>
      {!!content?.cta?.name && (
        <div className={styles.ctaButton} onClick={handleButtonClick}>
          {content?.cta?.name}
        </div>
      )}
      {!!content?.disclaimer && (
        <div className={styles.uidDisclaimer}>
          <span>{content?.disclaimer}</span>
        </div>
      )}
    </>
  )
}

export default ProductCTAButtonAndDisclaimer
